import { render, staticRenderFns } from "./ImportJsonModal.vue?vue&type=template&id=edc354ce&scoped=true"
import script from "./ImportJsonModal.vue?vue&type=script&lang=js"
export * from "./ImportJsonModal.vue?vue&type=script&lang=js"
import style0 from "./ImportJsonModal.vue?vue&type=style&index=0&id=edc354ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc354ce",
  null
  
)

export default component.exports